import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import ImageCropper from "../crop_image/ImageCropper";
import Swal from "sweetalert2";

function RecruitEdit() {
    const navigate = useNavigate();
    const { id_berkarir } = useParams();

    const [formValue, setFormValue] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
        judul: "",
        penjelasan: "",
    });

    const [preview, setPreview] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({
        cover: null,
        foto_1: null,
        foto_2: null,
        foto_3: null,
        foto_4: null,
        foto_5: null,
        foto_6: null,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/career/readCareerById/${id_berkarir}`
                );
                const data = response.data;

                setFormValue({
                    cover: null,
                    foto_1: null,
                    foto_2: null,
                    foto_3: null,
                    foto_4: null,
                    foto_5: null,
                    foto_6: null,
                    judul: data.judul,
                    penjelasan: data.penjelasan,
                });
                // langsung ambil path dari API tanpa tambahan prefix (sama seperti utschool)
                setPreview({
                    cover: data.cover,
                    foto_1: data.foto_1,
                    foto_2: data.foto_2,
                    foto_3: data.foto_3,
                    foto_4: data.foto_4,
                    foto_5: data.foto_5,
                    foto_6: data.foto_6,
                });
            } catch (error) {
                Swal.fire({
                    title: "Error",
                    text: "Gagal memuat data",
                    icon: "error",
                });
            }
        };
        fetchData();
    }, [id_berkarir]);

    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setSelectedFiles({
                ...selectedFiles,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, value, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: value,
            });
        }
    };

    const formatDeskripsi = (text) =>
        text
            .split("\n")
            .map((line) => `<p>${line}</p>`)
            .join("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        const { judul, penjelasan } = formValue;

        if (!judul || !penjelasan) {
            Swal.fire({
                title: "Error",
                text: "Semua field wajib diisi",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        if (selectedFiles.cover) FormDataInput.append("cover", selectedFiles.cover);
        if (selectedFiles.foto_1) FormDataInput.append("foto_1", selectedFiles.foto_1);
        if (selectedFiles.foto_2) FormDataInput.append("foto_2", selectedFiles.foto_2);
        if (selectedFiles.foto_3) FormDataInput.append("foto_3", selectedFiles.foto_3);
        if (selectedFiles.foto_4) FormDataInput.append("foto_4", selectedFiles.foto_4);
        if (selectedFiles.foto_5) FormDataInput.append("foto_5", selectedFiles.foto_5);
        if (selectedFiles.foto_6) FormDataInput.append("foto_6", selectedFiles.foto_6);
        FormDataInput.append("judul", judul);
        FormDataInput.append("penjelasan", formatDeskripsi(penjelasan));

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = `Bearer ${token}`;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            await axios.put(
                `${process.env.REACT_APP_API_URL}/career/updateCareer/${id_berkarir}`,
                FormDataInput,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            Swal.fire({
                title: "Success",
                text: "Data berhasil diperbarui",
                icon: "success",
            });
            navigate("/career");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal diperbarui",
                icon: "error",
            });
        }
    };

    return (
        <div className="wrapper recruitment-main">
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Administrasi</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item text-decoration-none">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Recruitment</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Edit Recruitment</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>Judul</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="judul"
                                                        value={formValue.judul}
                                                        onChange={handleChange}
                                                        placeholder="Masukkan Judul"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Deskripsi</label>
                                                    <textarea
                                                        className="form-control"
                                                        name="penjelasan"
                                                        value={formValue.penjelasan}
                                                        onChange={handleChange}
                                                        rows="3"
                                                        placeholder="Masukkan Deskripsi"
                                                    ></textarea>
                                                </div>

                                                <div className="form-group">
                                                    <label>Foto Cover</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name="cover"
                                                        accept="image/*"
                                                        onChange={handleChange}
                                                    />
                                                    {preview.cover && (
                                                        <div className="preview-container-gallery">
                                                            <img
                                                                src={preview.cover}
                                                                alt="Preview Cover"
                                                                className="preview-image-program"
                                                            />
                                                        </div>
                                                    )}
                                                </div>

                                                {Array.from({ length: 6 }, (_, index) => (
                                                    <div
                                                        className="form-group"
                                                        key={`foto_${index + 1}`}
                                                    >
                                                        <label>Foto {index + 1}</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            name={`foto_${index + 1}`}
                                                            accept="image/*"
                                                            onChange={handleChange}
                                                        />
                                                        {preview[`foto_${index + 1}`] && (
                                                            <div className="preview-container-gallery">
                                                                <img
                                                                    src={
                                                                        preview[`foto_${index + 1}`]
                                                                    }
                                                                    alt={`Preview Foto ${
                                                                        index + 1
                                                                    }`}
                                                                    className="preview-image-program"
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="card-footer">
                                                <button type="submit" className="btn btn-primary">
                                                    Simpan
                                                </button>
                                                <Link to="/career" className="btn btn-secondary">
                                                    Kembali
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {cropData.isOpen && (
                <ImageCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={setCroppedImage}
                    onCropComplete={applyCrop}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default RecruitEdit;
